import { render, staticRenderFns } from "./AddOutgoingType.vue?vue&type=template&id=56feef83&scoped=true&"
import script from "./AddOutgoingType.vue?vue&type=script&lang=js&"
export * from "./AddOutgoingType.vue?vue&type=script&lang=js&"
import style0 from "./AddOutgoingType.vue?vue&type=style&index=0&id=56feef83&prod&lang=scss&scoped=true&"
import style1 from "./AddOutgoingType.vue?vue&type=style&index=1&id=56feef83&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56feef83",
  null
  
)

export default component.exports